import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FullScreenToggleService {

  fullScreenEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }
}
